import {AuthModel} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

// Container de administrador do clube (companies.containers), o mesmo ADMIN_CONTAINER_ID do
// gateway do clube (shared/guards/club-staff.guard.ts).
const ADMIN_CONTAINER_ID = '91f5167c34c400758115c2a6826ec2e3'

// AAC-22: só para mostrar ou esconder itens de menu do administrador. Lê o `_container_id` do
// token salvo, sem validar a assinatura: quem protege de verdade é o gateway (403).
function ehAdministradorDoClube(): boolean {
  try {
    const payload = getAuth()?.api_token?.split('.')[1]
    if (!payload) return false
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const json = atob(base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '='))
    const container = JSON.parse(json)?._container_id
    return typeof container === 'string' && container.toLowerCase() === ADMIN_CONTAINER_ID
  } catch {
    return false
  }
}

export {getAuth, setAuth, removeAuth, ehAdministradorDoClube, AUTH_LOCAL_STORAGE_KEY}
